import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../store/store-provider';
import { Redirect, useParams } from 'react-router';
import { IRouteParams } from '../../pages/container/container';
import AttendeesContainer from './attendees-container/attendees-container';
import { getDefaultRoutePathByPermissions } from '../../utils/helpers/features-routes-helpers';
import './attendees.scss';
import { ChangeConnectionStatusConfirmationModal } from './attendee-connectin-control/cahnge-connection-status-confirmation-modal';

const Attendees = (): JSX.Element => {
  const { permissionsStore, attendeesStore } = useStore();
  const { isPodiumAttendeesEnabled } = permissionsStore;
  const { id } = useParams<IRouteParams>();
  const { getAttendeesInterval, clearPollingInterval } = attendeesStore;

  useEffect(() => {
    getAttendeesInterval();
    return () => clearPollingInterval();
  }, []);

  if (isPodiumAttendeesEnabled() != undefined && !isPodiumAttendeesEnabled()) {
    const path = getDefaultRoutePathByPermissions(permissionsStore);
    return <Redirect to={`/presentation/${id}${path}`}/>;
  }

  return (
    <section className='attendees-page'>
      <AttendeesContainer/>
      <ChangeConnectionStatusConfirmationModal/>
    </section>
  );
};

export default observer(Attendees);